import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { GraduationCap, Store, Clock } from "lucide-react";

const ICONS = [GraduationCap, Store, Store];

export const Program = () => {
  const { t } = useLang();

  return (
    <section id="program" data-testid="program-section" className="relative bg-ink py-24 text-cream md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <Reveal>
          <Overline dark>{t.program.overline}</Overline>
          <div className="mt-5 flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <h2 className="max-w-2xl font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl">
              {t.program.title}
            </h2>
            <p className="max-w-sm text-[15px] leading-relaxed text-cream/60">{t.program.note}</p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px bg-cream/10 md:grid-cols-3">
          {t.program.days.map((day, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={day.date} delay={i * 0.1} className="bg-ink">
                <article
                  data-testid={`program-day-${day.date}`}
                  className={`group flex h-full flex-col border border-transparent p-8 transition-colors duration-500 hover:border-gold/50 md:p-10 ${
                    i === 0 ? "bg-pine/25" : ""
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <span className="font-serif text-7xl font-semibold leading-none text-outline-cream transition-colors duration-500 group-hover:text-gold md:text-8xl">
                      {day.date}
                    </span>
                    <Icon size={22} className="mt-2 text-cream/40 transition-colors duration-500 group-hover:text-gold" />
                  </div>
                  <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
                    {day.dow} · {day.tag}
                  </p>
                  <h3 className="mt-3 font-serif text-2xl font-medium italic leading-tight md:text-3xl">
                    {day.title}
                  </h3>
                  <p className="mt-4 flex items-center gap-2 text-sm font-semibold text-cream" data-testid={`program-time-${day.date}`}>
                    <Clock size={14} className="text-gold" /> {day.time}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-cream/60">{day.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
